import { appBackendApiClient } from './apiClient';

export type UploadImageCategory =
  | 'cause-cover'
  | 'cause-gallery'
  | 'story-image'
  | 'misc';

export interface UploadImageResult {
  url: string;
  storageKey: string;
  contentType: string;
  size: number;
}

const readFileAsDataUrl = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error(`Failed to read ${file.name}`));
    reader.readAsDataURL(file);
  });

export const MediaUploadService = {
  /** Browser-side: read the file, post it to the admin upload endpoint, return the S3 URL. */
  async uploadImageFile(
    file: File,
    category: UploadImageCategory,
  ): Promise<UploadImageResult> {
    const dataUrl = await readFileAsDataUrl(file);
    const response = await appBackendApiClient.post<UploadImageResult>(
      '/admin/uploads/image',
      {
        dataUrl,
        fileName: file.name,
        category,
      },
    );
    return response.data;
  },
};
